import { SubmissionError } from '#helper/submission-error';
import { fetchAdditions, snackBarError } from '#action/fetch';
import { FETCH_PROJECT_ALERTS_CONFIRMATIONS, CLEAR_PROJECT_ALERTS_CONFIRMATIONS } from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

export const fetchProjectAlertConfirmations = id => dispatch =>
  dispatch(fetchAdditions(`project/${id}/accept-alert`, FETCH_PROJECT_ALERTS_CONFIRMATIONS, { id }));

export const putProjectAlertConfirmations = (id, alertConfirmations) => async dispatch => {
  try {
    const res = await fetch(webPortalApi.buildApiUrl(`project/${id}/accept-alert`), {
      method: 'PUT',
      body: JSON.stringify(alertConfirmations),
      ...getRequestOptions()
    });
    const response = await res.json();

    if (!res.ok) {
      dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );
      throw new SubmissionError(response);
    }

    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const clearProjectAlertConfirmations = () =>
  dispatch => dispatch({ type: CLEAR_PROJECT_ALERTS_CONFIRMATIONS });
